import { css } from '@emotion/core';
import BwModelicaLight from 'assets/fonts/BwModelica/BwModelica-Light.otf';
import BwModelicaRegular from 'assets/fonts/BwModelica/BwModelica-Regular.otf';
import BwModelicaMedium from 'assets/fonts/BwModelica/BwModelica-Medium.otf';
import BwModelicaBold from 'assets/fonts/BwModelica/BwModelica-Bold.otf';

import BwModelicaSS02Regular from 'assets/fonts/BwModelicaSS02/BwModelicaSS02-Regular.otf';
import BwModelicaSS02Medium from 'assets/fonts/BwModelicaSS02/BwModelicaSS02-Medium.otf';
import BwModelicaSS02Bold from 'assets/fonts/BwModelicaSS02/BwModelicaSS02-Bold.otf';

const globalStyle = css`
  @font-face {
    font-family: 'BwModelica';
    font-weight: 300;
    src: url(${BwModelicaLight}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'BwModelica';
    src: url(${BwModelicaRegular}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'BwModelica';
    font-weight: 500;
    src: url(${BwModelicaMedium}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'BwModelica';
    font-weight: 700;
    src: url(${BwModelicaBold}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'BwModelicaSS02';
    src: url(${BwModelicaSS02Regular}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'BwModelicaSS02';
    font-weight: 500;
    src: url(${BwModelicaSS02Medium}) format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'BwModelicaSS02';
    font-weight: 700;
    src: url(${BwModelicaSS02Bold}) format('truetype');
    font-display: swap;
  }

  html,
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  span,
  em,
  small,
  strong,
  sub,
  sup,
  mark,
  del,
  ins,
  strike,
  abbr,
  dfn,
  blockquote,
  q,
  cite,
  code,
  pre,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  div,
  section,
  article,
  main,
  aside,
  nav,
  header,
  hgroup,
  footer,
  img,
  figure,
  figcaption,
  address,
  time,
  audio,
  video,
  canvas,
  iframe,
  details,
  summary,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td {
    margin: 0;
    padding: 0;
    border: 0;
  }

  /* Typography
 * *********************************** */

  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
    -webkit-scroll-behavior: smooth;
  }

  body {
    font-family: BwModelica, sans-serif;
    font-size: 1.6rem;
    line-height: 1.4;
    scroll-behavior: smooth;
    -webkit-scroll-behavior: smooth;
    background: #000;
  }

  * {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  a,
  a:visited {
    // color: inherit;
  }

  /* Layout
 * *********************************** */

  article,
  aside,
  footer,
  header,
  nav,
  section,
  main {
    display: block;
  }

  * {
    box-sizing: border-box;
  }

  *:before,
  *:after {
    box-sizing: inherit;
  }

  /* Elements
 * *********************************** */

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  ul {
    list-style: none;
  }

  img,
  video {
    max-width: 100%;
  }

  img {
    border-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:after,
  blockquote:before,
  q:after,
  q:before {
    content: '';
    content: none;
  }

  /* Attributes & states
 * *********************************** */

  [hidden] {
    display: none !important;
  }

  [disabled] {
    cursor: not-allowed;
  }

  :focus:not(:focus-visible) {
    outline: none;
  }

  /* Utility classes
 * *********************************** */

  .sr-only {
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    left: -9999px;
    top: -9999px;
  }
`;

export default globalStyle;
